// import ApolloClient from 'apollo-boost';
// import { isMobile } from 'react-device-detect';

// from Apollo Boost
import ApolloClient from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
// For Subscription (websocket)
import { split } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { WebSocketLink } from 'apollo-link-ws';
import { getMainDefinition } from 'apollo-utilities';
// helpers
import { isMobile } from 'react-device-detect';

const subdomain = window.location.hostname.split('.')[0] || 'app';
console.log('process.env.REACT_APP_ENV', process.env.REACT_APP_ENV)
const wsUrl =
    process.env.REACT_APP_ENV === 'production'
        ? `wss://${subdomain}.facti.io`
        : isMobile
            ? 'ws://192.168.0.11:5000'
            : 'ws://localhost:5000';

// Create websocket link
const wsLink = new WebSocketLink({
  uri: `${wsUrl}/graphql`,
  options: {
    reconnect: true,
  },
});

const httpUrl =
  process.env.REACT_APP_ENV === 'production'
    ? `https://${subdomain}.facti.io`
    : isMobile
    ? 'http://192.168.0.11:5000'
    : `http://${subdomain}.facti.test:5000`;

// Create http link
const httpLink = new HttpLink({
  uri: `${httpUrl}/graphql`,
});

// seContext for authToken
const authLink = setContext(() => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('jwtToken');
  return {
    headers: {
      Authorization: token ? token : '',
    },
  };
});

// Concat http and authtoken link
const httpAuthLink = authLink.concat(httpLink);

// Split httpLink or wsLink
const link = split(
  // split link based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === 'OperationDefinition' && operation === 'subscription';
  },
  wsLink,
  httpAuthLink
);

const store = new ApolloClient({
  cache: new InMemoryCache(),
  link,
});

store.defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'none',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'none',
  },
  mutation: {
    errorPolicy: 'all',
  },
};

export default store;
